module.exports = __webpack_public_path__ + "img/50.b93cf6d3.png";